import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { mockData } from '../mock';

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-pink-400 to-pink-500 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-xl">CH</span>
              </div>
              <div>
                <h3 className="font-bold text-lg">Clean Home</h3>
                <p className="text-sm text-gray-400">Peterborough</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              Professional, insured, and DBS-checked cleaning services for homes and businesses in Peterborough.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>
                <Link to="/#services" className="hover:text-pink-400 transition-colors" data-testid="footer-services">Our Services</Link>
              </li>
              <li>
                <Link to="/#about" className="hover:text-pink-400 transition-colors" data-testid="footer-about">About Us</Link>
              </li>
              <li>
                <Link to="/#contact" className="hover:text-pink-400 transition-colors" data-testid="footer-contact">Contact</Link>
              </li>
              <li>
                <Link to="/shop" className="hover:text-pink-400 transition-colors" data-testid="footer-shop">Shop</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-pink-400 mt-0.5 flex-shrink-0" />
                <a href={`tel:${mockData.company.phone}`} className="hover:text-pink-400 transition-colors">
                  {mockData.company.phoneDisplay}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-pink-400 mt-0.5 flex-shrink-0" />
                <a href={`mailto:${mockData.company.email}`} className="hover:text-pink-400 transition-colors break-all">
                  {mockData.company.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-pink-400 mt-0.5 flex-shrink-0" />
                <span>{mockData.company.location}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Instagram className="w-5 h-5 text-pink-400 mt-0.5 flex-shrink-0" />
                <a href={mockData.company.instagramUrl} target="_blank" rel="noopener noreferrer" className="hover:text-pink-400 transition-colors">
                  {mockData.company.instagram}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Clean Home Peterborough. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
